<template>
  <div :style="[pageBgStyle]" id="app">
    <div class="header">
      <Header></Header>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <qrCode/>
    <sideBar />
    <applyform v-if="showApplyform" :tid="tid"/>
  </div>
</template>

<script>
import {EventBus} from "./event-bus.js";
import qrCode from '@/components/qrCode.vue';
import Header from "@/components/header";
// import asideNav from "@/components/asideNav";
import sideBar from "@/components/sideBar";
import applyform from "@/components/applyform.vue";
import {mapState} from 'vuex'

export default {
  name: 'App',
  components: {
    //HelloWorld
    qrCode,
    Header,
    sideBar,
    applyform,
  },
  data() {
    return {
      serverTel: '',
    }
  },
  mounted: function () {},
  computed: mapState([
    'pageBgStyle',
    'showApplyform',
    'tid'
  ]),
  methods: {
    // 判断移动端还是pc端
    initEventBus() {
      EventBus.$on("showQrcode", () => {
        console.log('showQrcode')
      });
    },
    initStore() {

    },
  },
  created() {
    /*
    this.cookies.set('name','test')
    console.log('this.cookies');
    console.log(this.cookies.get('name'));
    */

    this.initEventBus();
    this.initStore();
    this.getShortUrl();
    this.adTokenBd();
  },
}
</script>

<style lang="scss">
$note: 'screen and (max-width: 1280px)';

/*---- Mixins ----*/
@mixin mq($mqString) {
  @media #{$mqString} {
    @content;
  }
}
* {
  padding: 0;
  margin: 0;
  vertical-align: top;
  box-sizing: border-box;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
}

html, body {
  width: 100%;
  height: 100%;
  position: relative;
  font-family:  sans-serif;
}

li {
  list-style-type: none;
}

#app {
  width: 100%;
  min-height: 100vh;
  /* background-image: url('./assets/pageBg.jpg');
  background-size: 100% ;
  padding-bottom: 0.263157rem;
  font-size: 0.094736rem;
  min-height: 100%; */
}

.header{
  height: 108 * 0.8px;

  @include mq($note) {
    height: 70.4px;
  }
}

.themeColor {
  color: #a32928;
}

.demo {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
  opacity: 0.5;
}


.demo.hide {
  display: none;
}

h3 {
  color: #a32928;
  font-size: 0.105263rem;
  font-family:  sans-serif;
  text-align: center;
}

h4 {
  color: #a32928;
  font-size: 0.078947rem;
  font-family:  sans-serif;
  text-align: center;
}

.font1 {
  color: #fff;
  font-size: 0.078947rem;
  font-family:  sans-serif;
  text-align: center;
  display: block;
}


.page {

  width: 4.736842rem;
  margin-left: auto;
  margin-right: auto;
}

.top-state {
  background-image: url('./assets/top-state.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 1.347368rem;
  height: 0.2rem;
  margin-left: auto;
  margin-right: auto;
  color: #a32928;
  text-align: center;
  line-height: 0.2rem;
}

.page .container {

  position: relative;

}

.containerHeader {
  background-image: url('./assets/contentBgHeaderRed.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 4.736842rem;
  height: 0.347368rem;
}

.containerHeaderRed {
  background-image: url('./assets/contentBgHeaderRed.png');
}

.containerMiddle {
  background-image: url('./assets/contentBgmiddleRed.png');
  background-size: 100% auto;
  min-height: 0.105263rem;
  padding-left: 0.157894rem;
  padding-right: 0.157894rem;
  padding-bottom: 0.078947rem;
  padding-top: 1px;
}

.containerMiddleRed {
  background-image: url('./assets/contentBgmiddleRed.png');
}

.containerFooter {
  background-image: url('./assets/contenntBgFooterRed.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 4.736842rem;
  height: 0.252631rem;
}

.containerFooterRed {
  background-image: url('./assets/contenntBgFooterRed.png');
}

.containerHeader2 {
  background-image: url('./assets/contentBgHeader2.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 4.736842rem;
  height: 0.063157rem;
}

.containerMiddle2 {
  background-image: url('./assets/contentBgmiddle2.png');
  background-size: 100% auto;
  min-height: 0.105263rem;
  padding-bottom: 0.078947rem;
}

.containerFooter2 {
  background-image: url('./assets/contentBgFooter2.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 4.736842rem;
  height: 0.052631rem;
}


.page .content {
  background-color: #fff;
  border-radius: 10px;

  display: flex;
  min-height: 1.052631rem;
  flex-direction: column;
  margin-bottom: 0.078947rem;
  padding: 0.105263rem;
  justify-content: space-around;
  position: relative;
}


.page .content.center {
  justify-content: center;
}


.content .row {
  display: flex;
  justify-content: center;
}

.content .top {
  align-self: flex-start;
}


.content .bottom {
  align-self: flex-end;
}


.userInfo {
  display: flex;
  justify-content: center;
  align-items: center;

}

.userInfo .tx {
  /*background-image: url('./assets/txBg2.png');*/
  /*background-size: 100% auto;*/
  /*background-repeat: no-repeat;*/
  overflow: hidden;
  height: 0.357894rem;
}

.tx img {
  width: 0.357894rem;
}

.userInfo .name {
  color: #fff;
  padding-left: 0.052631rem;
  font-size: 0.136842rem;
}

.fontSize3 {
  font-size: 0.08421rem;
}

.fontSize2 {
  font-size: 0.136842rem;
}

.fontSize1 {
  font-size: 0.157894rem;

}

.bold {
  font-weight: bold;
}

.btn3 {
  position: relative;
  color: #fff;
  background-image: url('./assets/查看详情.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 0.626315rem;
  height: 0.168421rem;
  text-align: center;
  line-height: 0.168421rem;
  overflow: hidden;
}

.btn3:after {
  position: absolute;
  left: 0;
  top: -0.04rem;
  width: .06rem;
  height: 0.22rem;
  background-color: rgba(255, 255, 255, 0.4);
  transform: rotate(30deg);
  content: '';
  -webkit-animation: light-move 0.5s ease-out infinite;
  -o-animation: light-move 0.5s ease-out infinite;
  animation: light-move 0.5s ease-out infinite;
}

.btn3:before {
  position: absolute;
  left: 0;
  top: -0.04rem;
  width: .06rem;
  height: 0.22rem;
  background-color: rgba(225, 225, 225, 0.4);
  transform: rotate(30deg);
  content: '';
  animation: light-move-delay 0.5s ease-out infinite;
}


.textLeft {
  text-align: left !important;
}

.logo {
  width: 0.842105rem;
}

.logo img {
  width: 100%;
}


.detail_info {
  color: #a32928;
  font-size: 0.094736rem;
}


.detail_info img {
  max-width: 100%;
  display: block;
}

.portrait {
  border-radius: 50%;
}

@keyframes light-move {
  0% {
    left: -0.02rem
  }
  100% {
    left: 0.92rem;
  }
}

@keyframes light-move-delay {
  0% {
    left: -0.14rem
  }
  100% {
    left: 0.72rem;
  }
}

  /*特殊处理*/
#index-banner-img-1049{
  width: 260px;
  height: 260px;
  left: 40px;
  bottom: 20px;
}
#detail-banner-img-1049{
  width: 260px;
  height: 260px;
  left: 25px;
  top: -60px;
}

#detail-banner-img-1050{
  width: 280px;
  height: 280px;
  left: 25px;
  top: -75px;
}

</style>

